import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import '../StylesComponents/signin-page.css';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      await api.post('/api/auth/forgot-password', { email });
      setIsSubmitted(true);
    } catch (err) {
      console.error('RECOVERY_ERROR:', err);
      if (err.code === 'ECONNABORTED') {
        setError('SIGNAL_TIMEOUT: The server is taking too long to respond. Please try again.');
      } else {
        setError(err.response?.data?.error || 'Failed to initialize recovery protocol.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="signin-page-wrapper">
        <div className="signin-container glass-card animate-slide-up">
          <div className="signin-status-tag">
            <span className="pulse-dot"></span>
            RECOVERY_SIGNAL_TRANSMITTED
          </div>
          <h1 className="signin-heading">CHECK EMAIL</h1>
          <div className="auth-links">
            <p style={{ color: '#888', fontSize: '12px', lineHeight: '1.6', marginBottom: '20px' }}>
              If an account exists for <strong>{email}</strong>, a secure reset link has been dispatched to your terminal.
            </p>
            <Link to="/signin" className="brutalist-btn brutalist-btn-primary" style={{ textAlign: 'center' }}>
              RETURN_TO_SIGN_IN
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="signin-page-wrapper">
      <div className="signin-container glass-card animate-slide-up">
        <div className="signin-status-tag">
          <span className="pulse-dot"></span>
          PASSWORD_RECOVERY_PROTOCOL
        </div>
        <h1 className="signin-heading">RECOVER</h1>
        <p style={{ color: '#888', fontSize: '11px', marginBottom: '30px', fontFamily: 'var(--font-mono)' }}>
          Enter your registered email address to receive a secure access key reset link.
        </p>
        
        <form className="signin-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">EMAIL ADDRESS</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ENTER EMAIL"
              required
              className="technical-input"
            />
          </div>

          {error && <p style={{ color: '#ff4444', fontSize: '10px', marginTop: '10px' }}>{error}</p>}

          <button type="submit" className="brutalist-btn brutalist-btn-primary signin-button" disabled={isLoading}>
            {isLoading ? 'TRANSMITTING...' : 'INITIALIZE_RECOVERY'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/signin" style={{ fontSize: '11px', color: '#666' }}>BACK_TO_LOGIN</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
